import { ActionTypes } from '../actions/types';

const initialState = {
  hauptMandanten: [],
  currentUnterMandanten: [],
  freieMandanten: [],
  reloadHauptmandanten: false,
  reloadUntermandanten: false,
  anzeigeStati: [],
  currentSendungsStati: [],
  freieSendungsStati: [],
  reloadAnzeigeStati: false,
  reloadSendungsStati: false,
  reloadServerlog: false,
  adrImportMandanten: [],
  log: '',
  sessionCount: 0,
};

export default function (
  state = initialState,
  action: { type: ActionTypes; payload: any }
) {
  const { type, payload } = action;

  switch (type) {
    case ActionTypes.GET_HAUPTMANDANTEN:
      return {
        ...state,
        hauptMandanten: payload,
      };
    case ActionTypes.GET_CURRENTUNTERMANDANTEN:
      return {
        ...state,
        currentUnterMandanten: payload,
      };
    case ActionTypes.GET_FREIEMANDANTEN:
      return {
        ...state,
        freieMandanten: payload,
      };
    case ActionTypes.UPDATE_MANDANT:
      return {
        ...state,
        hauptMandanten: [...state.hauptMandanten, payload],
        reloadHauptmandanten: !state.reloadHauptmandanten,
      };
    case ActionTypes.UPDATE_UNTERMANDANT:
      return {
        ...state,
        currentUnterMandanten: [...state.currentUnterMandanten, payload],
        reloadUntermandanten: !state.reloadUntermandanten,
      };
    case ActionTypes.GET_ANZEIGESTATI:
      return {
        ...state,
        anzeigeStati: payload,
      };
    case ActionTypes.GET_CURRENTSENDUNGSSTATI:
      return {
        ...state,
        currentSendungsStati: payload,
      };
    case ActionTypes.GET_FREIESENDUNGSSTATI:
      return {
        ...state,
        freieSendungsStati: payload,
      };
    case ActionTypes.CREATE_ANZEIGESTATUS:
      return {
        ...state,
        anzeigeStati: [...state.anzeigeStati, payload],
      };
    /*case ActionTypes.DELETE_ANZEIGESTATUS:
    case ActionTypes.UPDATE_ANZEIGESTATUS:
      return {
        ...state,
        anzeigeStati: payload == null
            ? state.anzeigeStati
            : [...state.anzeigeStati, payload],
        reloadAnzeigeStati: !state.reloadAnzeigeStati,
      };
*/
    case ActionTypes.UPDATE_SENDUNGSSTATUS:
      return {
        ...state,
        reloadSendungsStati: !state.reloadSendungsStati,
      };

    case ActionTypes.ADRIMPORTMANDANT:
      return {
        ...state,
        adrImportMandanten: payload,
      };
    case ActionTypes.SERVERLOG:
      return {
        ...state,
        log: payload,
        reloadServerlog: !state.reloadServerlog,
      };
    case ActionTypes.SESSIONCOUNT:
      return {
        ...state,
        sessionCount: payload,
      };
    default:
      return state;
  }
}
